/* eslint-disable no-param-reassign */
import createStoreSelectors from '@stores/utils/createStoreSelector';
import create from 'zustand';
import notificationsType from '@cont/BatchGroup/constants';

const notifyMeInitialState = {
  onBlock: {
    title: 'A new similar batch will start soon',
    subtitle:
      'We can remind you when the new batch goes live so you don’t miss it'
  },
  onPriceCard: {
    title: 'A new similar batch will start soon',
    subtitle: 'We can notify you when it goes live'
  },
  onGoingBatches: {
    title: 'Get updates on this batch',
    subtitle: 'Get notified about upcoming demo classes, offers and more'
  }
};
const useStore = create((set) => ({
  notifyMeInfo: notifyMeInitialState,
  isNotified: {
    [notificationsType.UPCOMING_BATCHES]: false,
    [notificationsType.ONGOING_BATCHES]: false
  },
  isNotifyRequested: false,
  isNotificationFetched: false,
  setIsNotified: (isNotified) =>
    set((state) => {
      state.isNotified = { ...isNotified };
    }),
  setRequestedForNotifyMe: (isNotifyRequested) =>
    set((state) => {
      state.isNotifyRequested = isNotifyRequested;
    }),
  setNotificationFetchedStatus: (isNotificationFetched) =>
    set((state) => {
      state.isNotificationFetched = isNotificationFetched;
    })
}));

const useNotifyMe = createStoreSelectors(useStore);

const useNotifyMeStore = () => {
  return {
    isNotified: useNotifyMe.use.isNotified(),
    isNotifyRequested: useNotifyMe.use.isNotifyRequested(),
    isNotificationFetched: useNotifyMe.use.isNotificationFetched(),
    notifyMeInfo: useNotifyMe.use.notifyMeInfo(),
    setIsNotified: useNotifyMe.use.setIsNotified(),
    setRequestedForNotifyMe: useNotifyMe.use.setRequestedForNotifyMe(),
    setNotificationFetchedStatus: useNotifyMe.use.setNotificationFetchedStatus()
  };
};

export { useNotifyMeStore, useNotifyMe };
